import React, { useEffect } from "react";
import clsx from "clsx";
import DeleteActivitiesModal from "../sof/DeleteActivitiesModal";
import RejectLineHandlingModal from "../sof/RejectLineHandlingModal";
import SofIcon from "./Icons";
import UndoModal from "../sof/UndoModal";
import AttachmentModal from "../sof/AttachmentModal";
import { connect } from "react-redux";
import { FC } from "react";
import { last6Digits } from "../../services/Helper";
import { mergeStyleSets } from "office-ui-fabric-react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Nomination } from "../../models";
import { SofView } from "../../models";
import { State } from "../../store";
import { useState } from "react";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as SofViewStore from "../../store/SofViewStore";

type IProps = ActivityLogStore.ActivityLogsState &
  LineHandlingStore.LineHandlingState &
  SofViewStore.SofViewState &
  typeof LineHandlingStore.actionCreators &
  typeof SofViewStore.actionCreators;
const deleteActivitiesEnv: string[] = ["-dev", "-uat", "-sandbox", "localhost"];
const classes = mergeStyleSets({
  headerRow: {
    display: "flex",
    alignItems: "center",
    padding: "6px 24px",
    background: "white",
    borderBottom: "1px solid #E2E6E8",
  },
  headerRowTextPane: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    margin: "0 10px",
    paddingLeft: 10,
    borderLeft: "1px solid #E2E6E8",
  },
  headerTitle: {
    letterSpacing: "0.004em",
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: "bold",
  },
});
const NominationHeader: FC<IProps> = (props: IProps) => {
  const { lineHandling } = props;
  const [lineHandlingNo, setLineHandlingNo] = useState<string>();
  //const [selTransferType, setSelTransferType] = useState("");
  const history = useHistory();
  const navRef = React.createRef<any>();
  const startTransferSteps: number[] = [
    42, 65, 97, 120, 141, 142, 155, 156, 174, 175, 188, 189,
  ];

  const onLineHandlingClick = () => {
    props.deleteActiveNomination();
    props.setSofView(SofView.LineHandling);
    if (props.lineHandling.result)
      props.setSelectedState(props.lineHandling.result.currentState);
    //setSelTransferType("");
  };

  const onNominationChange = (nom: Nomination) => {
    props.setSofView(SofView.Nomination);
    //console.log("SEL: Nomination", nom);

    history.push(
      `/marine/${lineHandlingNo}/sof?nomination=${nom.nominationNo}`
    );
  };

  const onNominationView = () => {
    if (lineHandling.result) {
      const { nominations } = lineHandling.result;
      var uniqueTransferType = nominations
        .map((n) => n.transferType)
        .filter((value, index, self) => self.indexOf(value) === index);
      if (uniqueTransferType.length === 1) {
        onTransferTypeChange(uniqueTransferType[0]);
      } else {
        props.setSofView(SofView.None);
        history.push(`/marine/${lineHandlingNo}/sof`);
        console.log("navigate to sof");
      }
    }
  };

  const onTransferTypeChange = (transferType: string) => {
    props.setSofView(SofView.None);
    //setSelTransferType(transferType);

    if (props.lineHandling.result) {
      const count = props.lineHandling.result.nominations.filter(
        (f) => f.transferType === transferType
      );
      if (count && count.length === 1) {
        onNominationChange(count[0]);
        //setSelTransferType(count[0].transferType);
      }
    }
  };

  useEffect(() => {
    if (lineHandling.result) {
      setLineHandlingNo(lineHandling.result.lineHandlingNo);
    }
  }, [lineHandling.result]);

  useEffect(() => {
    props.setSofView(SofView.WorkPacket);
  }, []);

  return (
    <>
      {lineHandling.result && (
        <>
          <div className={classes.headerRow}>
            {
              <>
                {lineHandling.result.vesselType === "Vessel" ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_63_448"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_63_448)">
                      <path
                        d="M4.33463 18.4808L2.6654 12.4924C2.62182 12.3116 2.63945 12.1071 2.7183 11.8789C2.79713 11.6507 2.9577 11.4962 3.2 11.4154L4.5 10.9654V6.50006C4.5 5.99494 4.675 5.56738 5.025 5.21738C5.375 4.86738 5.80257 4.69238 6.3077 4.69238H9.5V1.69238H14.5V4.69238H17.6922C18.1974 4.69238 18.625 4.86738 18.975 5.21738C19.325 5.56738 19.5 5.99494 19.5 6.50006V10.9654L20.8 11.4154C21.0858 11.5231 21.2653 11.6869 21.3384 11.9068C21.4115 12.1266 21.423 12.3218 21.373 12.4924L19.6653 18.4808C18.9474 18.3846 18.2964 18.1455 17.7125 17.7635C17.1285 17.3814 16.5577 16.8769 16 16.25C15.4615 16.8705 14.865 17.4006 14.2105 17.8404C13.5561 18.2801 12.8192 18.5 12 18.5C11.1807 18.5 10.4439 18.2801 9.7894 17.8404C9.13492 17.4006 8.53844 16.8705 7.99998 16.25C7.44869 16.8769 6.87947 17.3814 6.2923 17.7635C5.70512 18.1455 5.05256 18.3846 4.33463 18.4808ZM2.25 22.5V21H3.99998C4.69998 21 5.39164 20.8917 6.07498 20.675C6.75831 20.4584 7.39998 20.1334 7.99998 19.7C8.59998 20.1334 9.24164 20.45 9.92497 20.65C10.6083 20.85 11.3 20.95 12 20.95C12.7 20.95 13.3916 20.85 14.075 20.65C14.7583 20.45 15.4 20.1334 16 19.7C16.6 20.1334 17.2416 20.4584 17.925 20.675C18.6083 20.8917 19.3 21 20 21H21.75V22.5H20C19.3 22.5 18.6166 22.4166 17.95 22.25C17.2833 22.0833 16.6333 21.8333 16 21.5C15.3666 21.8334 14.7125 22.0834 14.0375 22.25C13.3625 22.4167 12.6833 22.5 12 22.5C11.3166 22.5 10.6375 22.4167 9.96248 22.25C9.28748 22.0834 8.63331 21.8334 7.99998 21.5C7.36664 21.8334 6.71664 22.0834 6.04998 22.25C5.38331 22.4167 4.69998 22.5 3.99998 22.5L2.25 22.5ZM5.99997 10.4693L12 8.51928L18 10.4693V6.50003C18 6.41028 17.9711 6.33657 17.9134 6.27888C17.8557 6.22118 17.782 6.19233 17.6922 6.19233H6.3077C6.21795 6.19233 6.14423 6.22118 6.08653 6.27888C6.02883 6.33657 5.99997 6.41028 5.99997 6.50003V10.4693ZM12 17C12.7833 17 13.4426 16.7266 13.9778 16.1798C14.5131 15.6331 15.1872 14.8898 16 13.95C16.7936 14.85 17.3336 15.4635 17.6202 15.7904C17.9067 16.1173 18.25 16.3975 18.65 16.6308L19.75 12.65L12 10.1L4.2192 12.65L5.34998 16.6C5.74998 16.3667 6.09324 16.1 6.37978 15.8C6.66633 15.5 7.20639 14.8834 7.99998 13.95C8.83331 14.9 9.51248 15.6459 10.0375 16.1875C10.5625 16.7292 11.2166 17 12 17Z"
                        fill="#1C1B1F"
                      />
                    </g>
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_63_482"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    >
                      <rect width="24" height="24" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_63_482)">
                      <path
                        d="M2.25 18.5V16.9904C2.83847 16.9391 3.28431 16.7612 3.58753 16.4567C3.89073 16.1523 4.46988 16 5.325 16C6.22757 16 6.85673 16.1667 7.2125 16.5C7.56827 16.8333 8.04743 17 8.65 17C9.30257 17 9.79904 16.8333 10.1394 16.5C10.4798 16.1667 11.1 16 12 16C12.9 16 13.5202 16.1667 13.8606 16.5C14.201 16.8333 14.6974 17 15.35 17C15.9526 17 16.4317 16.8333 16.7875 16.5C17.1433 16.1667 17.7724 16 18.675 16C19.5494 16 20.1285 16.149 20.4125 16.4471C20.6965 16.7452 21.1423 16.9263 21.75 16.9904V18.5C20.9667 18.5 20.3984 18.3333 20.0452 18C19.692 17.6667 19.2269 17.5 18.65 17.5C18.0243 17.5 17.5352 17.6667 17.1827 18C16.8301 18.3333 16.2109 18.5 15.325 18.5C14.4122 18.5 13.7962 18.3333 13.4769 18C13.1577 17.6667 12.6654 17.5 12 17.5C11.3346 17.5 10.8423 17.6667 10.5231 18C10.2038 18.3333 9.58782 18.5 8.675 18.5C7.7891 18.5 7.16988 18.3333 6.81733 18C6.46476 17.6667 5.97565 17.5 5.35 17.5C4.76667 17.5 4.3016 17.6667 3.9548 18C3.60802 18.3333 3.03973 18.5 2.25 18.5ZM6.13465 14.5C5.7667 14.5 5.41382 14.433 5.076 14.299C4.73818 14.165 4.44043 13.966 4.18273 13.7019L2.99045 12.5L4.03465 11.4558L5.23655 12.6327C5.35578 12.7519 5.49233 12.843 5.64618 12.9058C5.80003 12.9686 5.96285 13 6.13465 13H7.50003V9.25961L6.17503 10.2346L5.28853 9.03849L12 4.10583L18.7019 9.02886L17.8154 10.25L16.5 9.28461V13H17.8654C18.0372 13 18.2 12.9686 18.3538 12.9058C18.5077 12.843 18.6442 12.7519 18.7635 12.6327L19.9654 11.4558L21.0096 12.5L19.8173 13.6923C19.5532 13.9564 19.2538 14.157 18.9192 14.2942C18.5846 14.4314 18.2333 14.5 17.8654 14.5H6.13465ZM9 13H11.25V11H12.75V13H15V8.17501L12 5.96539L9 8.16539V13Z"
                        fill="#1C1B1F"
                      />
                    </g>
                  </svg>
                )}
              </>
            }
            <div className={classes.headerRowTextPane}>
              <span id={`lbl-vehicle-name`} className={classes.headerTitle}>
                {last6Digits(lineHandlingNo)} - {lineHandling.result.vesselName}
              </span>
            </div>

            <div className="d-flex" style={{ gap: "16px" }}>
              <AttachmentModal />
              {lineHandling.result.status !== 4 && <UndoModal />}
              {props.activityLogs.result &&
                props.activityLogs.result.find(
                  (f) =>
                    startTransferSteps.indexOf(f.processStepId) >= 0 &&
                    f.status > 0
                ) === undefined && <RejectLineHandlingModal />}
              <div
                style={{
                  height: "40px",
                  width: "1px",
                  background: "#D8DFE6",
                  margin: "0",
                }}
              ></div>
              {deleteActivitiesEnv.some((substring) =>
                process.env.REACT_APP_AD_REDIRECT_URL.toLowerCase().includes(
                  substring
                )
              ) && <DeleteActivitiesModal />}
            </div>
          </div>
          <div
            className="btn-menu-group"
            style={{
              padding: "12px 24px",
              background: "white",
            }}
          >
            <div
              id="btn-toggle-line-handling"
              className={clsx(
                "btn-menu",
                props.sofView === SofView.LineHandling && "btn-menu-selected"
              )}
              onClick={() => navRef.current && navRef.current.click()}
            >
              Line Handling
            </div>
            <Link
              ref={navRef}
              style={{ display: "none" }}
              to={`/marine/${lineHandlingNo}/sof`}
              onClick={onLineHandlingClick}
            >
              Hidden line handling link
            </Link>
            <div
              id="btn-toggle-nomination"
              className={clsx(
                "btn-menu",
                props.sofView === SofView.Nomination && "btn-menu-selected"
              )}
              onClick={() =>
                history.push({
                  pathname: `/marine/${lineHandlingNo}/sof`,
                  state: {
                    fromDWP: true,
                  },
                })
              }
            >
              Nominations
            </div>
            <div
              onClick={() => {
                history.push(`/marine/${lineHandlingNo}/work-packets`);
              }}
              id="btn-toggle-nomination"
              className={clsx(
                "btn-menu",
                props.sofView === SofView.WorkPacket && "btn-menu-selected"
              )}
            >
              Work Packet
            </div>
            <div
              onClick={() => {
                history.push(`/marine/${lineHandlingNo}/services`);
              }}
              id="btn-toggle-nomination"
              className={clsx(
                "btn-menu",
                props.sofView === SofView.AdditionalServices &&
                  "btn-menu-selected"
              )}
            >
              Services
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default connect(
  (state: State) => ({
    ...state.lineHandling,
    ...state.activityLogs,
    ...state.sofView,
  }),
  { ...LineHandlingStore.actionCreators, ...SofViewStore.actionCreators }
)(NominationHeader as any);
